import type { PracticeBlock } from "@tutor/protocol";
import type { LearnerView } from "./types";

/**
 * Why practice cannot start right now, from the latest `practice.state`, or `null` when
 * it can. A block holds for the UTC day the actor sent it, so a pause ends at midnight UTC
 * without another event (ADR-0044 point 9).
 */
export function practiceBlock(view: LearnerView, now: Date = new Date()): PracticeBlock | null {
  const blocked = view.practice?.blocked ?? null;
  const today = Math.floor(now.getTime() / 86_400_000);
  return view.practice?.day === today ? blocked : null;
}
